import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import "aos/dist/aos.css";
import AOS from "aos";
import "./project.css"; // For custom styling
import shop from "../../assets/projectimg/shop.jpg";
import ogames from "../../assets/projectimg/oagmes.jpg";
import edu from "../../assets/projectimg/edu.jpg";
import dept from "../../assets/projectimg/dept.jpg";
import amazon from "../../assets/projectimg/amazon.jpg";



function Projects() {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a 1-second animation duration
  }, []);

  const projectData = [
    {
      id: 1,
      title: "OgamesStudio",
      text: "An Africa folklore-based game showcasing African cultures, especially Ghanaian heritage.",
      link: "https://www.ogamesstudio.com/",
      img: ogames, // Replace with actual image URL
    },
    {
      id: 2,
      title: "ShopeWorld",
      text: "An affiliate marketing site allowing users to shop easily on Amazon.",
      link: "https://sites.google.com/view/shopworld20/home?authuser=1",
      img: shop, // Replace with actual image URL
    },
    {
      id: 3,
      title: "MasterBasis",
      text: "A folklore-based game reflecting Ghanaian and African cultural values.",
      link: "https://letscode.streamlit.app/",
      img: edu, // Replace with actual image URL
    },
    {
      id: 4,
      title: "Fstudies",
      text: "A cryptocurrency mentorship app connecting mentors and mentees.",
      link: "https://sites.google.com/view/fstudies/about-us?authuser=1",
      img: dept, // Replace with actual image URL
    },
    {
      id: 5,
      title: "ShopeWide",
      text: "A cryptocurrency mentorship app connecting mentors and mentees.",
      link: "https://sites.google.com/view/shopwide/home?authuser=1",
      img: amazon, // Replace with actual image URL
    },
  ];

  return (
    <div className="projects-container">
      <h1 className="section-title" data-aos="fade-up">
        Projects
      </h1>
      <div className="projects-grid">
        {projectData.map((project) => (
          <Card
            key={project.id}
            style={{ width: "13rem" }}
            data-aos="zoom-in"
            className="project-card"
          >
            <Card.Img variant="top" src={project.img} alt={project.title}/>
            <Card.Body>
              <Card.Title>{project.title}</Card.Title>
              <Card.Text>{project.text}</Card.Text>
              <Button className="explore-button-custom">
                <a href={project.link} className="explore-link">
                  Explore
                </a>
              </Button>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default Projects;
